export default __webpack_public_path__ + "static/media/services1.c11872e9.png";